import React from "react";
import { formatTimeForLocale } from "../../../../../utils/booking";
import { useUserContext } from "../../../../../hooks/useUserContext";

type DividerProps = {
  style: React.CSSProperties;
  isOnRunSheet?: boolean;
  item: any;
};

export const Divider = ({ style, isOnRunSheet, item }: DividerProps) => {
  const { user } = useUserContext();

  // Use BEM class for runsheet or Tailwind component class for default
  const dividerClassName = isOnRunSheet
    ? "DiaryBookingCard__divider runsheet"
    : "DiaryBookingCardList__TimeDivider diary-time-divider";

  return (
    <div className={dividerClassName} style={{ ...style }}>
      {formatTimeForLocale(item.time, user?.locale)}
    </div>
  );
};
